module.exports = __webpack_public_path__ + "img/blog-25.14072ff1.webp";